import { IStore } from 'Store/.';
import { createSelector } from 'reselect';

const getIsFetching = (state: IStore) => state.infoTerms.isFetching;
const getIsFetchFailed = (state: IStore) => state.infoTerms.isFetchFailed;
const getTermsContent = (state: IStore) => state.infoTerms.content;

export {
  getIsFetching,
  getIsFetchFailed,
  getTermsContent,
};


// WEBPACK FOOTER //
// ./src/pages/InfoTermsPage/Redux/selectors.tsx